export enum Theme {
  theme1 = 'Design-2019',
  theme3 = 'Design-2023',
}

export enum PractitionerProfession {
  acupuncturist = 'ACUPUNCTURIST',
  cardiologist = 'CARDIOLOGIST',
  chiropractor = 'CHIROPRACTOR',
  dentist = 'DENTIST',
  gastroenterologist = 'GASTROENTEROLOGIST',
  internist = 'INTERNIST',
  naturopath = 'NATUROPATH',
  neurologist = 'NEUROLOGIST',
  neuropsychologist = 'NEUROPSYCHOLOGIST',
  nurse_practitioner = 'NURSE_PRACTITIONER',
  oncologist = 'ONCOLOGIST',
  orthopedic = 'ORTHOPEDIC',
  physical_therapist = 'PHYSICAL_THERAPIST',
  physician = 'PHYSICIAN',
  radiologist = 'RADIOLOGIST',
}

export enum BiologicalSex {
  female = 'female',
  male = 'male',
}

export enum ShareMethod {
  email = 'Email',
  fax = 'Fax',
  cd = 'CD',
  usb = 'USB',
}

export interface Option {
  label: string;
  value: string;
}

export interface User {
  address?: string;
  city?: string;
  country?: string;
  dob?: string;
  email?: string;
  fakeDob?: string;
  fakeFirstname?: string;
  fakeLastname?: string;
  firstname?: string;
  gender?: string;
  lastname?: string;
  phn?: string;
  phoneNumber?: string;
  postalCode?: string;
  roles?: string[];
  signature?: string;
  state?: string;
  status?: string;
  userId?: string;
}

export interface Referrer {
  firstName?: string;
  lastName?: string;
  mspPrescriber?: string;
  mspNumber?: string;
  prenuvoId?: string;
  signature?: string;
}

export type HexColorString = '#${string}';

export interface Country {
  label: string;
  code: string;
}

export interface Address {
  address1: string;
  address2: string | null;
  city: string;
  state: string;
  postalCode: string;
  country: Country;
}

export interface Price {
  total: number | null;
  perMonth: string | null;
  referralValue: number | null;
  currency: string | null;
}

export interface Sku {
  description?: string;
  marketedTime?: number;
  name: string;
  price: Price;
  shortName: string;
  skuID: string;
}

export interface Payment {
  paymentToken: string;
  paymentType: string;
  paymentUrl: string;
}

export interface Location {
  address: Address;
  code: string;
  displayTimezone: string;
  externalLender: string;
  name: string;
  payments: Payment[];
  skus: Sku[];
  timezone: string;
  machines: {
    code: string;
    name: string;
  }[];
}

export interface Slot {
  machines: string[];
  utcEnd: number;
  utcStart: number;
  day?: string;
  dayOfWeek?: string;
  hour?: string;
  min?: string;
  month?: string;
  partOfDay?: string;
}

export interface SlotsItem {
  availableSlots: Slot[];
  date: string; // YYYY-MM-DD
}

export interface SlotEvent {
  machineId: string;
  utcEnd: number;
  utcStart: number;
}

export type MaskTemplateTypes = 'dob' | 'fullname' | string;
